export default __webpack_public_path__ + "static/media/Jon_ll_Boyd_AHV_In_Moms_We_Trust.74986c40.jpg";